import React, { useEffect, useState } from 'react';
import { IonButton, IonContent, IonFooter, IonIcon, IonItem, IonLabel, IonList, IonModal, IonSpinner, IonText } from '@ionic/react';
import { _dict, _possibleCardColors } from './constants';
import { useGlobalStore } from './stateManagement/globalZustand';
import { useURLStore } from './stateManagement/URLZustand';
import { useHistory } from 'react-router';
import { enter, playCircle } from 'ionicons/icons';
import { useTreeStore } from './stateManagement/treeZustand';
import { isYoutubeUrl } from './usePhotoGallery';
import { useUIStore } from './stateManagement/UIZustand';
import ButtonTemplate from './templates/ButtonTemplate';
import { Sound, getTTSOptions } from './useRecorder';
import { useTts } from 'tts-react';
import VoiceRecorder from './RecordButton';

interface IROtherOptionsProps {
    showModal: boolean;
    setShowModal: (show: boolean) => void;
    IRLabel: string;
    handleIRDismiss: () => void;
}

const IROtherOptions: React.FC<IROtherOptionsProps> = ({ showModal, setShowModal, IRLabel, handleIRDismiss }) => {
    const { lang } = useGlobalStore();
    const { getURLTo } = useURLStore();
    const { l2Color, setL2Color, l2Audio, l2Image, setL2Audio } = useTreeStore();
    const { setVideoURL } = useUIStore();
    const history = useHistory();
    const [isRecording, setIsRecording] = useState(false);
    const { play } = useTts(getTTSOptions(lang, IRLabel)); 
    const [showPlayBtn, setShowPlayBtn] = useState<boolean>(true);
    const [playBtnContent, setPlayBtnContent] = useState<any>();


    useEffect(() => {
        if (showPlayBtn === true) {
          setPlayBtnContent(null);
        } else {
          setPlayBtnContent(<IonSpinner />);
        }
    
      }, [isRecording, showPlayBtn]);
      
      const buttonTemplate = (onClick: any,
        icon: any, text: string,
        color: string = "light",
        className: string = "",
        alternativeIcon: any = null,
        fontSize = "18px") => <IonButton
          color={color}
          style={{ padding: 0, height: "60px", fontSize: fontSize}}
          expand='block'
          onClick={(event)=> {event.preventDefault(); onClick()}}
          className={className}
          
        >
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            {alternativeIcon === null ? <IonIcon size="large" icon={icon} /> : alternativeIcon}
            {text}
          </div>
        </IonButton>

      /* REF-BTN: PLAY */
    
  const handlePlaySound = async () => {
      // Play audio if available
      if (l2Audio.hasOwnProperty(IRLabel)) {
        await new Promise(resolve => {
          const audioRef = new Audio(`data:${l2Audio[IRLabel].mimeType};base64,${l2Audio[IRLabel].base64}`);
          audioRef.onended = resolve;
          audioRef.play();
        });
      } else if (isYoutubeUrl(l2Image[IRLabel])) {
        // Handle YouTube URL without waiting
        setVideoURL(l2Image[IRLabel]);
      }else{
        play();
      }
  };
  //const playBtn = <ButtonTemplate onClick={async () => { await handlePlaySound() }} icon={playCircle} text={_dict.playSound[lang]} />;
  const playBtn = buttonTemplate(isRecording ? undefined : async () => { await handlePlaySound() }, playCircle, _dict.playSound[lang], "light", "", playBtnContent);
  /* REF-BTN: RECORD */
  const handleRecordingComplete = (sound: Sound) => {
    setIsRecording(false);
    setShowPlayBtn(true);

    const updatedL2Audio = { ...l2Audio };
    updatedL2Audio[IRLabel] = sound;
    setL2Audio(updatedL2Audio);
  };

  
  const handleRecordClick = () => {
    setShowPlayBtn(false);
  };
  const recordBtn = <div onClick={handleRecordClick} style={{ padding: 0, height: "60px" }}>
      <VoiceRecorder
        lang={lang}
        onRecordingComplete={handleRecordingComplete}
        style={{ padding: 0, height: "60px" }}
      />
    </div>;
  
  
  
    

    const handleClickOnOpen = () => {
        history.push(getURLTo().talkFromNextNodePath(IRLabel));
        setShowModal(false);
        handleIRDismiss();
    }
    const handleColorSelection = (color:string) => {
        setL2Color({...l2Color, [IRLabel]: color});
    }
    return (
        <>
            <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
                <IonContent>
                    <IonList>
                        <IonItem onClick={handleClickOnOpen}>
                            <IonLabel><ButtonTemplate onClick={handleClickOnOpen} icon={enter} text={_dict.open[lang]} isBlack={true} /></IonLabel>

                            
                        </IonItem>
                        <IonItem >
                        
                            <IonLabel>
                            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems:"center", justifyContent:"center"}}><IonText>{_dict.changeColor[lang]}</IonText></div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems:"center", justifyContent:"center" }}> {/* Add flex display and optionally wrap content */}
                            
                                {_possibleCardColors.map((color) => (
                                <div
                                    key={color}
                                    onClick={() => handleColorSelection(color)}
                                    style={{
                                    backgroundColor: color,
                                    width: '50px', // Ensure width is specified for horizontal arrangement
                                    height: '50px',
                                    margin: '5px',
                                    cursor: 'pointer',
                                    border: '1px solid #333333',
                                    flexShrink: 0, // Prevent the square from shrinking if space is limited
                                    }}
                                ></div>
                                ))}
                            
                            </div>
                            </IonLabel>
                        </IonItem>
                        
                        <IonItem>
                            <IonLabel>{playBtn}</IonLabel>
                        </IonItem>
                        <IonItem>
                            <IonLabel>{recordBtn}</IonLabel>
                        </IonItem>
                    </IonList>
                    
                </IonContent>
                <IonFooter>
                    <IonButton color="danger" expand="full" onClick={() => setShowModal(false)}>
                        {_dict.close[lang]}
                    </IonButton>
                </IonFooter>
            </IonModal>
            
        </>
    );
};

export default IROtherOptions;
